import _extends from "@babel/runtime/helpers/extends";
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

import React from 'react';
import { EuiDelayRender, EuiSkeletonText, EuiFormControlLayout, EuiErrorBoundary, useEuiTheme } from '@elastic/eui';
import { jsx as ___EmotionJSX } from "@emotion/react";
export { monaco } from '@kbn/monaco';
export * from './react_monaco_editor/languages/supported';
const LazyCodeEditorBase = /*#__PURE__*/React.lazy(() => import(/* webpackChunkName: "code-editor-entry" */'./code_editor').then(m => ({
  default: m.CodeEditor
})));
const Fallback = ({
  height
}) => {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    style: {
      ...(height ? {
        minHeight: height
      } : {}),
      width: '100%'
    }
  }, ___EmotionJSX(EuiDelayRender, null, ___EmotionJSX(EuiSkeletonText, {
    lines: 3
  }))));
};

/**
 * Renders a Monaco code editor with EUI color theme.
 *
 * @see CodeEditorField to render a code editor in the same style as other EUI form fields.
 */
export const CodeEditor = props => {
  return ___EmotionJSX(EuiErrorBoundary, null, ___EmotionJSX(React.Suspense, {
    fallback: ___EmotionJSX(Fallback, {
      height: props.height
    })
  }, ___EmotionJSX(LazyCodeEditorBase, props)));
};

/**
 * Renders a Monaco code editor in the same style as other EUI form fields.
 */
export const CodeEditorField = props => {
  const {
    width,
    height,
    options,
    fullWidth
  } = props;
  const {
    euiTheme
  } = useEuiTheme();
  const style = {
    width,
    height,
    backgroundColor: options !== null && options !== void 0 && options.readOnly ? euiTheme.colors.backgroundBaseDisabled : euiTheme.colors.backgroundBaseSubdued
  };
  return ___EmotionJSX(EuiErrorBoundary, null, ___EmotionJSX(React.Suspense, {
    fallback: ___EmotionJSX(Fallback, {
      height: props.height
    })
  }, ___EmotionJSX(EuiFormControlLayout, {
    append: ___EmotionJSX("div", {
      hidden: true
    }),
    style: style,
    readOnly: options === null || options === void 0 ? void 0 : options.readOnly,
    fullWidth: fullWidth
  }, ___EmotionJSX(LazyCodeEditorBase, _extends({}, props, {
    transparentBackground: true
  })))));
};